





































import { Component, Vue } from 'vue-property-decorator';
import { MenuLang } from '@/lang/en/menu';
import Menu from '@/utils/menu';
import AuthService from '@/services/auth';
import { $router } from '@/main';
import { currentAppVersion } from '@/main';
import { Lang } from '@/lang/en/login.ts';

import StAndrewsLogo from '@/assets/img/logo_final_gold_no_title.svg';

@Component({
  components: {
    StAndrewsLogo,
  },
})
export default class Main extends Vue {
  private menuLang: object = MenuLang;
  private menu: object = Menu;
  private lang: object = Lang;
  private appVersion: any = currentAppVersion;
  private logOut: any = {
    title: 'Log Out',
    icon: 'logout',
    navigation: 'logoff',
  };

  private doLogout = () => {
    AuthService.Logout();
  }

  private navigateTo = (path) => {
    $router.push({
      name: path,
    });
  }
}
